import { type PropType, type Component } from "vue";

export type NotificationType = "success" | "error" | "warning" | "info";

export interface NotificationItem {
    id: number;
    type: NotificationType;
    title?: string;
    text?: string;
    component?: Component;
    html?: string;
    duration: number;
}

export interface NotificationParams {
    title?: string;
    text?: string;
    type?: NotificationType;
    component?: Component;
    html?: string;
    duration?: number;
}

export const notificationProps = {
    notifications: {
        type: Array as PropType<NotificationItem[]>,
        required: true as const,
    },
};

export const notificationEmits = {
    close: (event: number | string) => event,
};
